function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.7 22.3L16 14.6C17.2 13.1 18 11.1 18 9C18 4 14 0 9 0C4 0 0 4 0 9C0 14 4 18 9 18C11.1 18 13.1 17.3 14.6 16L22.3 23.7C22.7 24.1 23.3 24.1 23.7 23.7C24.1 23.3 24.1 22.7 23.7 22.3ZM9 16C5.1 16 2 12.9 2 9C2 5.1 5.1 2 9 2C12.9 2 16 5.1 16 9C16 12.9 12.9 16 9 16Z",
  fill: "#101010"
});

function SvgSearch({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMy43IDIyLjNMMTYgMTQuNkMxNy4yIDEzLjEgMTggMTEuMSAxOCA5QzE4IDQgMTQgMCA5IDBDNCAwIDAgNCAwIDlDMCAxNCA0IDE4IDkgMThDMTEuMSAxOCAxMy4xIDE3LjMgMTQuNiAxNkwyMi4zIDIzLjdDMjIuNyAyNC4xIDIzLjMgMjQuMSAyMy43IDIzLjdDMjQuMSAyMy4zIDI0LjEgMjIuNyAyMy43IDIyLjNaTTkgMTZDNS4xIDE2IDIgMTIuOSAyIDlDMiA1LjEgNS4xIDIgOSAyQzEyLjkgMiAxNiA1LjEgMTYgOUMxNiAxMi45IDEyLjkgMTYgOSAxNloiIGZpbGw9IiMxMDEwMTAiLz4KPC9zdmc+Cg==";
export { SvgSearch as ReactComponent };